import { REMI_INTERNAL_ORG } from "@remi/types/organizations";

import { hasCapability, type User } from "../base";

export const escalationHub = {
  read: (user: User) => {
    return (
      hasCapability(user, "escalationHub.read") ||
      user.person.regionRoles.includes("REGIONAL_MANAGER") ||
      user.person.regionRoles.includes("CORPORATE_PARTNER_POC")
    );
  },
  write: (user: User) => {
    return hasCapability(user, "escalationHub.write") || user.person.regionRoles.includes("REGIONAL_MANAGER");
  },
  // Same grant scope as escalationHub.read; unlike write, must never gate edits, transitions, or dismissals.
  flag: (user: User) => {
    return hasCapability(user, "escalationHub.flag") || user.person.regionRoles.includes("REGIONAL_MANAGER");
  },
  createTicket: (user: User) => hasCapability(user, "escalationHub.createTicket"),
  dismiss: (user: User) => hasCapability(user, "escalationHub.dismiss"),
  // Escalation banner visibility on bids/projects/tasks/tickets/conversations. Granted to every
  // Remi-internal role (broader than escalationHub.read — Remi staff who can't open the hub still
  // see the at-a-glance flag), and to no contractor/partner/homeowner role.
  readBanner: (user: User) => hasCapability(user, "escalationHub.readBanner"),
  // Status-only (no escalation id or details) for site inspectors on the mobile project screen.
  readFieldStatus: (user: User) =>
    hasCapability(user, "escalationHub.readFieldStatus") || hasCapability(user, "escalationHub.readBanner"),
  // The job context screen names other contractors and shows the homeowner's risk tier, so contractor-org
  // crews holding FIELD_WORKER are excluded; only Remi staff see it.
  readFieldJobContext: (user: User) =>
    user.person.organizationId === REMI_INTERNAL_ORG.id && escalationHub.readFieldStatus(user),
};
